import cn from 'classnames';
import { ICertificateDetailTerm } from "@/entities/Certificates";
import { convertIsoToDate } from "@/shared/lib/utils/dateAdapters";
import { Section } from "@/shared/ui/Section";
import { getColorObject } from "@/shared/lib/utils/getColorClass";

interface CourseStatementOfGradesProps {
  terms: ICertificateDetailTerm[];
}

export const CourseStatementOfGrades = ({ terms }: CourseStatementOfGradesProps) => (
  <Section>
    <h3 className="text-[24px] font-semibold mb-6">Statement of grades</h3>
    <ul className="flex flex-col gap-5">
      {terms.map((term) => (
        <li key={`term-${term.number}`} className='p-4'>
          <div className="flex items-center justify-between gap-4">
            <h3 className="text-[24px] font-medium">Term {term.number}</h3>
            <p className="text-sm font-medium text-gray-secondary min-w-[78px]">{convertIsoToDate(term.startDate)} - {convertIsoToDate(term.endDate)}</p>
          </div>

          {term.modules.length > 0 && <ul className="flex flex-col gap-3 mt-4">
            {term.modules.map((module) => {
              const percent = typeof module.grade === 'number' ? module.grade : typeof module.formativeCompletionPercent === 'number' ? module.formativeCompletionPercent : null;
              const { bgColor, textColor } = getColorObject(percent);
              return <li key={module.id} className="flex items-center justify-between gap-4">
                <p className="font-medium text-grey-secondary">{module.title}</p>
                {percent ?
                  <div className={cn("w-[78px] min-w-[78px] flex items-center justify-center rounded-[100px] py-1 px-5 font-medium text-sm", textColor, bgColor)}>
                    {percent}%
                  </div> : <p className="min-w-[78px]">-</p>}
              </li>
            }
            )}
          </ul>}
        </li>
      ))}
    </ul>
  </Section>
);
